(function () {
  'use strict';

  // Loads sitewide (not gated to the two mug product pages) so it covers a cart
  // mutation triggered from any page -- specifically Rebuy's Smart Cart drawer,
  // which is reachable from the header on every page, not just /cart (which it
  // has replaced entirely; Dawn's own /cart page is unreachable in real traffic
  // as of 2026-08-31). Split out of tsd-customize.js, which stays gated to the
  // two product pages for the button/modal only. Self-scoping regardless of
  // where it runs: only ever touches cart lines carrying the _custom_ref
  // property, i.e. this feature's own product/fee pairs -- never any other line.
  //
  // Pairs by _custom_ref, not variant: each modal submission gets a unique ref,
  // so Shopify never merges two submissions' lines, even of the same variant.
  // Removing either line of a pair removes the other -- a customized line left
  // without its fee would check out unbilled and skip the ShipStation hold,
  // which keys on the fee line's title (CL-396).

  var API_BASE = 'https://custom-order-portal-production.up.railway.app';
  var FEE_FOR_PROPERTY = '_tsd_fee_for';
  var REF_PROPERTY = '_custom_ref';

  var configPromise = null;
  function getConfig() {
    if (!configPromise) {
      configPromise = fetch(API_BASE + '/api/tsd-custom/config')
        .then(function (r) {
          if (!r.ok) throw new Error('config fetch failed');
          return r.json();
        })
        .catch(function (err) {
          configPromise = null;
          throw err;
        });
    }
    return configPromise;
  }

  var CART_MUTATING_PATTERNS = ['/cart/change.js', '/cart/update.js', '/cart/add.js', '/cart/clear.js'];
  var syncing = false;

  function isCartMutation(url) {
    return CART_MUTATING_PATTERNS.some(function (p) {
      return String(url).indexOf(p) !== -1;
    });
  }

  function initCartGuard() {
    var originalFetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = originalFetch.apply(this, arguments);
      if (!syncing && isCartMutation(url)) {
        result.then(reconcileCart).catch(function () {});
      }
      return result;
    };
    reconcileCart();
  }

  function reconcileCart() {
    if (syncing) return;
    Promise.all([fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }), getConfig()])
      .then(function (results) {
        var cart = results[0];
        var config = results[1];

        var skuByVariant = {};
        Object.keys(config.products).forEach(function (sku) {
          var p = config.products[sku];
          skuByVariant[String(p.variant_id)] = p;
        });

        var pairs = {};
        cart.items.forEach(function (item) {
          var ref = item.properties && item.properties[REF_PROPERTY];
          if (!ref) return;
          var pair = pairs[ref] || (pairs[ref] = { product: null, fee: null });
          if (item.properties[FEE_FOR_PROPERTY]) {
            pair.fee = item;
          } else {
            pair.product = item;
          }
        });

        var removals = [];
        var updates = [];
        Object.keys(pairs).forEach(function (ref) {
          var pair = pairs[ref];
          if (!pair.fee) {
            removals.push(pair.product.key);
            return;
          }
          if (!pair.product) {
            removals.push(pair.fee.key);
            return;
          }
          var pconf = skuByVariant[String(pair.product.variant_id)];
          if (!pconf) return;
          var expectedQty = pair.product.quantity * pconf.units_per_qty;
          if (pair.fee.quantity !== expectedQty) {
            updates.push({ id: pair.fee.key, quantity: expectedQty });
          }
        });

        if (!removals.length && !updates.length) return;

        syncing = true;
        var chain = Promise.resolve();
        removals.forEach(function (key) {
          chain = chain.then(function () {
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
          });
        });
        updates.forEach(function (u) {
          chain = chain.then(function () {
            return fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: u.id, quantity: u.quantity })
            });
          });
        });
        return chain.then(function () {
          window.location.reload();
        });
      })
      .catch(function () {
        syncing = false;
      });
  }

  document.addEventListener('DOMContentLoaded', initCartGuard);
})();
